import { render, staticRenderFns } from "./serviceBillDetail.vue?vue&type=template&id=f47b925a&scoped=true"
import script from "./serviceBillDetail.vue?vue&type=script&lang=js"
export * from "./serviceBillDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./serviceBillDetail.vue?vue&type=style&index=1&id=f47b925a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47b925a",
  null
  
)

export default component.exports